import { DataSourceRecordFormatBase } from "abweb/dto/generated/ds/DataSourceRecordFormatBase";
import { DataSourceRecord } from "abweb/dto/ds/DataSourceRecord";
import { DataSourceValueVector } from "abweb/dto/ds/DataSourceValueVector";
import { ClassUtils } from "abweb/utils/ClassUtils";
export class DataSourceRecordFormat extends DataSourceRecordFormatBase {
  static createWithDefaults(fields, name) {
    return DataSourceRecordFormat.createDataSourceRecordFormat(
    // So why can't this just be called 'create' ?
    false, fields, name // So why isn't this called 'id' - as is with DataSource{,Record} ?
    );
  }
  static createDataSourceRecordFormat(editable, fields, name) {
    const retVal = new DataSourceRecordFormat();
    retVal.initDataSourceRecordFormat(editable, fields, name);
    return retVal;
  }
  findField(fieldPath) {
    if (!this.fields) {
      return null;
    }

    // 1st check to see if there's a match for fieldPath "as is" ("DataSet.Application", for instance, in test data)
    const value = this.fields[fieldPath];
    if (value != null) {
      return value;
    }
    const dotIndex = fieldPath.indexOf(".");
    if (dotIndex < 0) {
      return value; // null or undefined
    }

    // Use recursive walk
    const thisFieldName = fieldPath.substring(0, dotIndex);
    const field = this.fields[thisFieldName];
    if (field == null) {
      return null;
    }
    return field.findField(fieldPath.substring(dotIndex + 1));
  }
  setUpFields(recs, dataSource, parentRecord = null, containerRec = null) {
    for (const rec of recs) {
      rec._dataSource = dataSource;
      rec._parentRecord = parentRecord;
      rec._containerRecord = containerRec;
      if (!this.fields) {
        return;
      }
      for (const i in this.fields) {
        if (this.fields.hasOwnProperty(i)) {
          const f = this.fields[i];
          if (rec.values && f.name && rec.values[f.name])
            // TODO: should null values still have a _field?
            {
              const dsv = rec.values[f.name];
              dsv._field = f;
              dsv._containerRecord = rec;
              dsv._dataSource = dataSource;
              if (ClassUtils.isInstanceOf(dsv, DataSourceValueVector)) {
                if (f.itemType) {
                  f.itemType.setUpVectorFields(dsv, rec, dataSource);
                } else {
                  // Must be a DYNAMIC field
                  for (const item of dsv.items) {
                    item._field = null;
                    item._containerRecord = dsv;
                    item._dataSource = dataSource;
                    item.initializeState();
                  }
                }
              } else if (ClassUtils.isInstanceOf(dsv, DataSourceRecord)) {
                if (f.recordFormat) {
                  f.recordFormat.setUpFields([dsv], dataSource, parentRecord, rec);
                }
              } else {
                // Assume we have a simple non-container DataSourceValue
                dsv.initializeState();
              }
            }
        }
      }
      if (rec.childRecords != null && rec.childRecords.length > 0) {
        this.setUpFields(rec.childRecords, dataSource, rec, containerRec); // TODO Transitional cast
      }
    }
  }
  constructor() {
    super();
  }
}
//# sourceMappingURL=DataSourceRecordFormat.js.map
